var map = {
	"./Border down.svg": "./src/components/SkyrimFrame/img/Border down.svg",
	"./Border left down.svg": "./src/components/SkyrimFrame/img/Border left down.svg",
	"./Border left top.svg": "./src/components/SkyrimFrame/img/Border left top.svg",
	"./Border left.svg": "./src/components/SkyrimFrame/img/Border left.svg",
	"./Border middle.svg": "./src/components/SkyrimFrame/img/Border middle.svg",
	"./Border right down.svg": "./src/components/SkyrimFrame/img/Border right down.svg",
	"./Border right top.svg": "./src/components/SkyrimFrame/img/Border right top.svg",
	"./Border right.svg": "./src/components/SkyrimFrame/img/Border right.svg",
	"./Border top.svg": "./src/components/SkyrimFrame/img/Border top.svg",
	"./Header left-2.svg": "./src/components/SkyrimFrame/img/Header left-2.svg",
	"./Header left.svg": "./src/components/SkyrimFrame/img/Header left.svg",
	"./Header right-2.svg": "./src/components/SkyrimFrame/img/Header right-2.svg",
	"./Header right.svg": "./src/components/SkyrimFrame/img/Header right.svg",
	"./Header top 3 1.svg": "./src/components/SkyrimFrame/img/Header top 3 1.svg",
	"./Header top.svg": "./src/components/SkyrimFrame/img/Header top.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/SkyrimFrame/img sync recursive ^\\.\\/.*\\.svg$";